import type React from 'react';
import type { ReactNode } from 'react';
import { useContext } from 'react';

import classNames from 'classnames';

import type { FCC } from '../../../../types/common';
import { FormContext } from '../../form_context/form_context';

import styles from './form_field_label.module.css';

type Props = {
  required?: boolean;
  htmlFor?: string;
  className?: string;
  width?: string;
  onClick?: (event: React.MouseEvent) => void;
  adornment?: ReactNode;
};

const FormFieldLabel: FCC<Props> = ({
  children,
  required,
  htmlFor,
  className,
  width,
  onClick,
  adornment,
}) => {
  const { isVertical } = useContext(FormContext);
  return (
    <div
      className={classNames(styles.label, className, {
        [styles.vertical]: isVertical,
        [styles.with_adornment]: Boolean(adornment),
      })}
      style={{ width }}
    >
      <label htmlFor={htmlFor} onClick={onClick}>
        {children}
        {required ? '\u00a0*' : ''}
      </label>
      {adornment}
    </div>
  );
};

export default FormFieldLabel;
